/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { actionOptions } from '../options/action.options';

/**
 * Action directive
 */
export const actionDirective = {
  /**
   * Options container
   */
  options: actionOptions,

  /**
   * @type {Map<string, {element: Element, options: object}}
   */
  container: new Map(),

  /**
   * Initialize plugin for the given element or elements which match the selector
   *
   * @param {Element} element HTML DOM element
   * @param {object}  options Additional plugin options
   */
  init(element, options = {}) {
    const action = element.getAttribute('amb-action');

    const clickListener = (event) => {
      switch (action) {
        case 'scroll_to_section': this.scrollToSection(event, options); break;
        default: break;
      }
    };

    if (action === 'collapse_event') {
      this.registerCollapseEvent(element, options);
    }

    element.addEventListener('click', clickListener);

    this.container.set(element.ambid, { clickListener });
  },

  /**
   * Destroy plugin for the given element
   *
   * @param {Element} element HTML DOM element
   */
  destroy(element) {
    const action = element.getAttribute('amb-action');
    const { clickListener, collapseListener } = this.container.get(element.ambid);

    if (clickListener) {
      element.removeEventListener('click', clickListener);
    }

    if (action === 'collapse_event') {
      $(element.dataset.target).off('hidden.bs.collapse shown.bs.collapse', collapseListener);
    }

    this.container.delete(element.ambid);
  },

  /**
   * @param {Element} element HTML DOM element
   * @param {object}  options Additional plugin options
   */
  registerCollapseEvent(element, options = {}) {
    const { onHidden, onShown } = options;
    const target = $(element.dataset.target);

    const collapseListener = (event) => {
      switch (event.type) {
        case 'hidden': element.classList.toggle('d-none', onHidden === 'hide'); break;
        case 'shown': element.classList.toggle('d-none', onShown === 'hide'); break;
        default: break;
      }
    };

    if (onHidden) {
      target.on('hidden.bs.collapse', collapseListener);
    }

    if (onShown) {
      target.on('shown.bs.collapse', collapseListener);
    }
  },

  /**
   * Scroll to the section resolved from `options.target` (or the link's `href`). A
   * `amb:scroll-to-section` custom event is dispatched on the trigger element BEFORE the
   * browser starts scrolling so any owning chrome (e.g. sticky navigation) can prepare its
   * layout synchronously — keeping DOM-specific concerns out of this directive.
   *
   * @param {Event} event The event that triggered the scroll
   * @param {ScrollIntoViewOptions & { target?: string }} options
   *   Optional `target` selector overrides the link's `href`; remaining keys are forwarded to
   *   `Element.scrollIntoView`.
   * @fires amb:scroll-to-section CustomEvent { detail: { target: Element } }, bubbles
   */
  scrollToSection(event, options = {}) {
    event.preventDefault();

    const { target = event.currentTarget.getAttribute('href'), ...scrollOptions } = options;
    const targetElement = document.querySelector(target);

    if (!targetElement) {
      return;
    }

    if (target === '#interior-container') {
      $('input[name="view"][value="interior"]').trigger('click');
    }

    const scrollEvent = new CustomEvent('amb:scroll-to-section', {
      bubbles: true,
      detail: { target: targetElement }
    });

    event.currentTarget.dispatchEvent(scrollEvent);

    if (!scrollEvent.defaultPrevented) {
      targetElement.scrollIntoView(scrollOptions);
    }
  }
};
